export default __webpack_public_path__ + "static/media/misc-drawerA-2048w.1d8afe4a.png";